/**
 * Prosedyremessig gange for korridor-avataren (spilltest-funn: figuren
 * «glir» som en sjakkbrikke fordi den er ett statisk bilde på en tween).
 *
 * Ren matte uten Phaser-avhengighet: scenen sender inn medgått gang-tid
 * og får tilbake en pose (bob-løft, vuggevinkel, skyggeskala) som legges
 * på figuren INNE i avatar-containeren — fotpunkt og skygge blir stående
 * på gulvet. Skrittindeksen lar scenen utløse støv/lyd per nedslag.
 */

/** Skritt per sekund — rask kontorgange, matcher GANGFART på ~550 px/s. */
export const SKRITT_PER_SEK = 3;

/** Hvor høyt figuren løftes midt i skrittet. */
export const BOB_AMPLITUDE_PX = 6;

/** Maks vuggevinkel (radianer) — ±3 grader. */
export const VUGG_MAKS_RAD = (3 * Math.PI) / 180;

/** Hvor mye skyggen krymper når figuren er på toppen av bobben. */
const SKYGGE_PULS = 0.12;

export interface GangePose {
  /** Løft i px — trekkes fra figurens y (positiv = opp fra gulvet). */
  bob: number;
  /** Rotasjon i radianer rundt fotpunktet. */
  vinkel: number;
  /** Skala-faktor for skygge-ellipsen (1 = fot i gulvet). */
  skyggeSkala: number;
}

/** Pose etter tMs millisekunder sammenhengende gange. */
export function gangePose(tMs: number): GangePose {
  const fase = (tMs / 1000) * SKRITT_PER_SEK * Math.PI;
  // |sin| gir nedslag (bob=0) ved hvert skritt og topp midt imellom.
  const lopeKurve = Math.abs(Math.sin(fase));
  return {
    bob: lopeKurve * BOB_AMPLITUDE_PX,
    // sin skifter fortegn ved hvert nedslag: annenhver side, som vektskifte.
    vinkel: Math.sin(fase) * VUGG_MAKS_RAD,
    skyggeSkala: 1 - lopeKurve * SKYGGE_PULS,
  };
}

/** Antall fullførte skritt etter tMs — øker med ett per nedslag. */
export function skrittIndeks(tMs: number): number {
  return Math.floor((tMs / 1000) * SKRITT_PER_SEK);
}
